import { render } from "./HomeView.vue?vue&type=template&id=df07ffbc&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=df07ffbc&scoped=true&lang=css"

import exportComponent from "/home/webcoom/Documents/www/esim-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df07ffbc"]])

export default __exports__